const translation = {
  title: 'Model Train',
  createTask: 'Create Training Task',
  baseModel: 'Base Model',
  dataset: 'Dataset',
  config: 'Training Config',
  newTask: {
    startToCreate: 'Start to create a new model training task',
  },
  task: {
    title: 'Training Task',
    edit: 'Edit Training Task',
    create: 'Create Training Task',
  },
  template: {
    title: 'Training Template',
    create: {
      title: 'Create Training Template',
    },
    tab: {
      detail: 'Detail',
      cronjobs: 'Cronjobs',
      manualjobs: 'Manualjobs',
    },
    detail: {
      title: 'Training Template Detail',
    },
  },
  tasks: {
    detail: 'Detail',
    log: 'Log',
    event: 'Event',
    monitor: 'Monitor',
    pod: 'Pod',
  },
  taskList: {
    idAndName: 'Name / ID',
    status: 'Status',
    permission: 'Permission',
    model: 'Training Framework',
    modelName: 'Model Name',
    dataset: 'Dataset',
    resourceInfo: 'Resource Info',
    config: 'Training Config',
    crontab: 'Crontab',
    lastRunAt: 'Last Run At',
    createdAt: 'Created At',
    updatedAt: 'Updated At',
    operations: 'Operations',
    createTrain: 'Create Training',
    edit: 'Edit',
    delete: 'Delete',
    start: 'Start',
    stop: 'Stop',
    log: 'Log',
    copy: 'Copy',
    more: 'More',
    create: 'Create',
    searchPlaceholder: 'Search',
    view: 'View',
    createTask: 'Create Task',
    createTemplate: 'Create Template',
    editTask: 'Edit Task',
    editTemplate: 'Edit Template',
    deleteTask: 'Delete Task',
    deleteTemplate: 'Delete Template',
    startTask: 'Start Task',
    stopTask: 'Stop Task',
    logTask: 'Log Task',
    copyTask: 'Copy Task',
    moreTask: 'More Task',
    moreTemplate: 'More Template',
    unknown: 'Unknown',
  },
  resourceSelector: {
    billingMode: 'Billing Mode',
    payg: 'Pay-as-you-go',
    reservedDay: 'Daily Reserved',
    reservedWeek: 'Weekly Reserved',
    availableRegions: 'Available Regions',
    resourceCluster: 'Resource Cluster',
    resourceQueue: 'Resource Queue',
    resourceGpu: 'GPU Model',
    numGpu: 'GPU Num',
    resourceSpec: 'Resource Specification',
    instanceCount: 'Instance Count',
    resourceRequired: 'Resource is required',
    billingModeRequired: 'Billing mode is required',
    regionRequired: 'Region is required',
    clusterRequired: 'Resource cluster is required',
    queueRequired: 'Resource queue is required',
    specRequired: 'Resource specification is required',
    instanceCountRequired: 'Instance count is required',
    unitHour: '￥ / hour'
  },
  // TrainingTaskForm component entries
  form: {
    name: 'Name',
    permission: 'Permission',
    description: 'Description',
    resource: 'Training Resource',
    framework: 'Training Framework',
    environment: 'Training Environment',
    baseModel: 'Base Model',
    modelVersion: 'Model Version',
    trainingData: 'Training Data',
    datasetVersion: 'Dataset Version',
    volumeMounts: 'Volume Mounts',
    workingDir: 'Working Directory',
    cmd: 'Start Command',
    args: 'Start Arguments',
    env: 'Environment Variables',
    restartPolicy: 'Restart Policy',
    restartCount: 'Restart Count',
    outputModel: 'Output Model',
    outputModelName: 'Output Model Name',
    modelPath: 'Model Path',
    confirm: 'Confirm',
    cancel: 'Cancel',
    saveTemplate: 'Save as Template',
    templateName: 'Template Name',
    templateNameRequired: 'Template name cannot be empty',
    // Dynamic text
    resourceName: 'Resource Name',
    resourcePermission: 'Resource Permission',
    resourceDescription: 'Resource Description',
    resourcePermissionRequired: 'Resource permission is required',
    // Restart policy options
    never: 'Never',
    onFailure: 'On Failure',
    always: 'Always',
    // Storage types
    diskStorage: 'Disk Storage',
    s3Storage: 'S3 Storage',
    // Tooltip text
    permissionTooltip: 'Set access permission for the training task: private is visible only to you, public is visible to all project members',
    descriptionTooltip: 'Brief description of the training task for easier identification and management',
    resourceTooltip: 'Select computing resources for the training task, including GPU type, quantity and instance specification',
    frameworkTooltip: 'Select the deep learning framework for training, such as PyTorch, TensorFlow, etc.',
    environmentTooltip: 'Select the container image for the training task. The image should contain the training framework and required dependencies',
    baseModelTooltip: 'Select the base pretrained model for fine-tuning or continued training',
    modelVersionTooltip: 'Select the specific version of the base model',
    trainingDataTooltip: 'Select the dataset for training. The dataset will be mounted into the container',
    datasetVersionTooltip: 'Select the specific version of the dataset',
    volumeMountsTooltip: 'Mount storage disks, models or datasets to specified container paths for data access and persistent storage',
    workingDirTooltip: 'Working directory path when the container starts. Startup commands will be executed in this directory',
    cmdTooltipIntro:
      'System environment variables and custom startup parameters can be referenced using "{{variable_name}}".',
    cmdTooltipSystemVars: 'System environment variables are:',
    argsTooltip:
      'Custom startup parameters that can be referenced in startup variables',
    envTooltip: 'Set environment variables for the container runtime, used to configure hyperparameters and training parameters',
    restartPolicyTooltip: 'Set the restart policy when training task fails: Never, On Failure, or Always',
    outputModelTooltip: 'Storage location and name for the output model after training completes',
    crontabTooltip: 'Set scheduled execution rules to automatically run training tasks at specified intervals',
    datasetName: 'Dataset name',
    trainId: 'Training task ID',
    trainName: 'Training task name',
    outputModelStorageRequired: 'Output model storage is required',
    outputModelNamePlaceholder: 'Output model name',
    s3PathPlaceholder: 's3://bucket-name/path',
    diskModelPath:
      'Model path: "Storage disk root directory"/models/{{modelName}}',
    s3ModelPath: 'Model path: {{s3Path}}/{{modelName}}',
    // Validation messages
    frameworkRequired: 'Training framework is required',
    environmentRequired: 'Training environment is required',
    baseModelRequired: 'Base model is required',
    restartPolicyRequired: 'Restart policy is required',
    restartCountRequired: 'Restart count is required',
    // Action text
    updateTrainingTask: 'Update Training Task',
    createTrainingTask: 'Create Training Task',
    saveAsTemplate: 'Save as Template',
    inputTemplateName: 'Please enter template name',
    // Cost related
    totalCost: 'Total Cost',
    perHour: '/Hour',
  },
  edit: {
    title: 'Edit Training Template',
  },
  model: {
    title: 'Model Management',
    create: {
      title: 'Create Model',
    },
    edit: {
      title: 'Edit Model',
    },
    detail: {
      title: 'Model Detail',
    },
    versions: {
      title: 'Model Versions',
    },
    tab: {
      detail: 'Detail',
      versions: 'Versions',
      files: 'Files',
    },
  },
}

export default translation
